export default {
  PROCESS: 'Process',
  EFFECT: 'Effect',
  ADJUST: 'Adjustment',

  PROCESS_ORIGIN: 'Origin',
  PROCESS_GRAYSCALE: 'Grayscale',
  PROCESS_SOBEL: 'Sobel',
  PROCESS_INVERT: 'Invert',
  PROCESS_SEPIA: 'Sepia',
  
  ADJUST_LIGHTNESS: 'Lightness',
  ADJUST_HUE: 'Hue',
  ADJUST_SATURATION: 'Saturation',
  ADJUST_ALPHA: 'Alpha',
  ADJUST_GAMMA: 'Gamma',
  ADJUST_POSTERIZE: 'Posterize',

  EFFECT_ORIGIN: 'Origin',
  EFFECT_OLD: 'Old',
  EFFECT_LINEDRAWING: 'LineDrawing',
  EFFECT_OILDRAWING: 'OilDrawing',
  EFFECT_NATURAL: 'Natural',
}